export const GET_ORDERS = "GET_ORDERS";
export const GET_ACTIVE_ORDERS = "GET_ACTIVE_ORDERS";
export const GET_PREVIOUS_ORDERS = "GET_PREVIOUS_ORDERS";
export const CLEAR_ORDERS = "CLEAR_ORDERS";
export const UP_DATE_STATUS_ORDER = "UP_DATE_STATUS_ORDER";
export const RESPONSE_UP_DATE_STATUS_ORDER = "RESPONSE_UP_DATE_STATUS_ORDER";
export const changePreparation = "changePreparation";
